import type { DialogueData } from '@/core/types/contracts';

/** Dialogue data registry keyed by id. Chapter builders register their JSON here. */
export const DIALOGUES: Record<string, DialogueData> = {};
export function registerDialogues(list: DialogueData[]): void { for (const d of list) DIALOGUES[d.id] = d; }
export function getDialogue(id: string): DialogueData | undefined { return DIALOGUES[id]; }
